import { Tooltip, TooltipProps as TooltipPropsType } from './tooltip';
import { LazyTooltip } from './lazy';

export type TooltipProps = TooltipPropsType;

export default Tooltip;
export { Tooltip, LazyTooltip };
